module.exports = __webpack_public_path__ + "static/seo-fitness-mobile-solution-3c2fb6d64dd4885a6d112a15316dfc9b.png";